/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon20Light = forwardRef('ArrowCollapseCVClosedIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.414 8.293a2 2 0 0 1-2.828 0l-4.44-4.44a.5.5 0 1 1 .708-.707l4.439 4.44a1 1 0 0 0 1.414 0l4.44-4.44a.5.5 0 0 1 .707.708l-4.44 4.439Z" }),
        React.createElement("path", { d: "M11.414 11.707a2 2 0 0 0-2.828 0l-4.44 4.44a.5.5 0 0 0 .708.707l4.439-4.44a1 1 0 0 1 1.414 0l4.44 4.44a.5.5 0 0 0 .707-.708l-4.44-4.439Z" })));
});
